require('./bootstrap')
require('es6-promise/auto')

import focus from '@alpinejs/focus'

import Swiper from 'swiper'
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, Thumbs } from 'swiper/core'

import { gsap, Power3 } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { TextPlugin } from 'gsap/TextPlugin';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';
import { CustomEase } from "gsap/CustomEase";
import { CustomWiggle } from "gsap/CustomWiggle"; // extends CustomEase
import { SplitText } from "gsap/SplitText";
import Pikaday from 'pikaday/pikaday'
import moment from 'moment';
import 'moment-timezone';

Alpine.plugin(focus)

gsap.registerPlugin(SplitText, CustomEase, CustomWiggle, ScrollTrigger, TextPlugin, Power3, ScrambleTextPlugin);

SwiperCore.use([Navigation, Scrollbar, Pagination, Autoplay, Thumbs])

// slide out menu
require('@cmyee/pushy/js/pushy.min')

require('lightgallery/dist/js/lightgallery-all')

require('waypoints/lib/jquery.waypoints.min')

window.Pikaday = Pikaday;

window.moment = moment;

// Tooltip
$(function () {
    $('[data-bs-toggle="tooltip"]').tooltip()
})

$(window).on(
    'load',
    function () {
        setTimeout(
            function () {
                $('body').addClass('loaded')
            },
            500
        )
    }
)

$(document).ready(
    function () {
        $(document).on("click", ".side-nav__link-button[data-menu]", function () {
            let subMenuNo = $(this).data('menu')
            let subMenu = $('.side-nav__slider[data-menu-parent="' + subMenuNo + '"]')
            let backBtn = $('.side-nav__back')

            $('.side-nav__slider').removeClass('active')
            subMenu.addClass('active')
            backBtn.addClass('active')
        })

        $(document).on("click", ".side-nav__back", function () {
            let subMenu = $('.side-nav__slider')
            let backBtn = $(this)

            subMenu.removeClass('active')
            backBtn.removeClass('active')
        })

        if ($('.slide-search').length) {
            $('.slide-search').click(
                function (e) {
                    e.preventDefault()
                    $('.side-nav__search input[name=search]').focus()
                }
            )
        }

        if ($('.gallery-item').length) {
            $('body').lightGallery(
                {
                    download: false,
                    counter: false,
                    selector: '.gallery-item',
                    autoplayControls: false,
                    fullScreen: false,
                    zoom: false,
                    share: false,
                    rotate: false,
                }
            )
        }
    }
)

$(document).on(
    'click',
    '.header__search-btn',
    function (e) {
        e.preventDefault()
        if ($('.header__search').hasClass('show')) {
            $('.header__search-btn').removeClass('show')
            $('.header__search').removeClass('show')
            $('.header__nav').removeClass('hide')
        } else {
            $('.header__nav').addClass('hide')
            setTimeout(() => {
                    $('.header__search-btn').addClass('show')
                    $('.header__search').addClass('show')
                    $('.header__search .form-control').focus()
                },
                300)
        }
    }
)

if ($('#acceptCookies').length) {
    $(document).on('click', '#acceptCookies', function () {
        $('#cookieNotice').remove()
        axios.post('/cookie-notice', { accept: true })
    });
}

if ($('#declineCookies').length) {
    $(document).on('click', '#declineCookies', function () {
        $('#cookieNotice').remove()
        axios.post('/cookie-notice', { accept: false }).then(() => {
            window.location.reload()
        })
    })
}

if ($('.testimonials-slider').length) {
    let testimonialsSlider = new Swiper(".testimonials-slider", {
        slidesPerView: 1,
        spaceBetween: 12,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        pagination: {
            el: ".testimonials-slider__pagination",
            clickable: true
        },
        scrollbar: {
            hide: false,
            draggable: true,
            el: '.testimonials-slider__scrollbar'
        },
        navigation: {
            clickable: true,
            nextEl: ".testimonials-slider__next",
            prevEl: ".testimonials-slider__prev"
        },
        mousewheel: true,
        keyboard: true,
        breakpoints: {

            1024: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
            1280: {
                slidesPerView: 2,
                spaceBetween: 62,
            },
            1600: {
                slidesPerView: 2,
                spaceBetween: 84,
            },

        }
    });
}

if ($('#bannerHome').length) {

    var textContent1 = $('#banner_heading').data('content-1');
    var textContent2 = $('#banner_heading').data('content-2');
    var textContent3 = $('#banner_heading').data('content-3') || 'Waste Management';

    var subheading1 = $('#banner_heading').data('subheading-1');
    var subheading2 = $('#banner_heading').data('subheading-2');
    var subheading3 = $('#banner_heading').data('subheading-3');

    var link1 = $('#banner_heading').data('link-1');
    var link2 = $('#banner_heading').data('link-2');
    var link3 = $('#banner_heading').data('link-3');

    var textLink1 = $('#banner_heading').data('link-text-1');
    var textLink2 = $('#banner_heading').data('link-text-2');
    var textLink3 = $('#banner_heading').data('link-text-3');

    // Function to update subheading and link for the current banner
    function updateBannerContent(subheading, textLink, link) {
        $('#subheading').html(subheading);
        $('#bannerBtn').html(textLink);
        $('#bannerBtn').attr('href', link);
    }

    // Hide all images function
    function hideAllImages() {
        gsap.set('#skipimages img, #toilet0, #toilet1, #toilet2, #waste', { autoAlpha: 0 });
    }

    // Function to calculate typing duration
    function getTypingDuration(text, speedPerChar = 0.1) {
        return text.length * speedPerChar;
    }

    // Skip Banner Timeline
    var skipBanner = new gsap.timeline({
        paused: true,
        repeat: 1,
        yoyo: true,
        onComplete: () => {
            toiletBanner.restart();
        },
        onStart: () => {
            updateBannerContent(subheading1, textLink1, link1);
            hideAllImages(); // Hide other images
        }
    });

// Calculate typing duration for textContent1
    var typingDuration1 = getTypingDuration(textContent1, 0.1);

    skipBanner.to('#text_typing_animation', {
        text: { value: textContent1 },
        delay: 0.5,
        duration: typingDuration1,
        ease: "none"
    }, 0);

    skipBanner.to('#text_line', {
        width: "100%",
        duration: typingDuration1,
        ease: "none"
    }, 0); // Starts at the same time as typing animation

// Animate the #skip SVG
    skipBanner.fromTo('#skip', {
        autoAlpha: 0,
        x: '100%'
    }, {
        autoAlpha: 1,
        x: '0%',
        duration: 1,
        ease: "power2.out",
        delay: 0.7
    }, 0);

    skipBanner.to('#text_typing_animation', { xPercent: 0, delay: 2 }, '+=0');

    // Toilet Banner Timeline
    var toiletBanner = new gsap.timeline({
        paused: true,
        repeat: 1,
        yoyo: true,
        onComplete: () => {
            wasteBanner.restart();
        },
        onStart: () => {
            updateBannerContent(subheading2, textLink2, link2);
            hideAllImages(); // Hide other images
        }
    });

    // Calculate typing duration for textContent2
    var typingDuration2 = getTypingDuration(textContent2, 0.1);

    toiletBanner.to('#text_typing_animation', {
        text: { value: textContent2 },
        delay: 0.5,
        duration: typingDuration2,
        ease: "none"
    }, 0);

    toiletBanner.to('#text_line', {
        width: "100%",
        duration: typingDuration2,
        ease: "none"
    }, 0.5); // Starts at the same time as typing animation

    toiletBanner.fromTo('#toilet0', {
        autoAlpha: 0,
        y: '10px'
    }, {
        autoAlpha: 1,
        y: '0',
        delay: 0.2
    }, 0);

    toiletBanner.fromTo('#toilet1', {
        autoAlpha: 0,
        y: '10px'
    }, {
        autoAlpha: 1,
        y: '0',
        delay: 0.4
    }, 0);

    toiletBanner.fromTo('#toilet2', {
        autoAlpha: 0,
        y: '10px'
    }, {
        autoAlpha: 1,
        y: '0',
        delay: 0.6
    }, 0);

    toiletBanner.to('#text_typing_animation', { xPercent: 0, delay: 2 }, '+=0');

    // Waste Banner Timeline
    var wasteBanner = new gsap.timeline({
        paused: true,
        repeat: 1,
        yoyo: true,
        onComplete: () => {
            skipBanner.restart();
        },
        onStart: () => {
            updateBannerContent(subheading3, textLink3, link3);
            hideAllImages(); // Hide other images
        }
    });

    // Calculate typing duration for textContent3
    var typingDuration3 = getTypingDuration(textContent3, 0.1);

    wasteBanner.to('#text_typing_animation', {
        text: { value: textContent3 },
        delay: 0.5,
        duration: typingDuration3,
        ease: "none"
    }, 0);

    wasteBanner.to('#text_line', {
        width: "100%",
        duration: typingDuration3,
        ease: "none"
    }, 0.5); // Starts at the same time as typing animation

    wasteBanner.fromTo('#waste', {
        autoAlpha: 0,
        x: '100%'
    }, {
        autoAlpha: 1,
        x: '0%',
        duration: 1,
        ease: "power2.out",
        delay: 0.7
    }, 0);

    wasteBanner.to('#text_typing_animation', { xPercent: 0, delay: 2 }, '+=0');

    // Start the animation sequence
    $(window).on("load", function (e) {
        skipBanner.play();
    });
}

// Banner LOO page
if ($('#bannerLoos').length) {

    var textContent1 = $('#banner_heading').data('content-1');
    var textContent2 = $('#banner_heading').data('content-2');
    var textContent3 = $('#banner_heading').data('content-3');

    var subheading1 = $('#banner_heading').data('subheading-1');
    var subheading2 = $('#banner_heading').data('subheading-2');
    var subheading3 = $('#banner_heading').data('subheading-3');

    var link1 = $('#banner_heading').data('link-1');
    var link2 = $('#banner_heading').data('link-2');
    var link3 = $('#banner_heading').data('link-3');

    var textLink1 = $('#banner_heading').data('link-text-1');
    var textLink2 = $('#banner_heading').data('link-text-2');
    var textLink3 = $('#banner_heading').data('link-text-3');

    // Function to update subheading and link for the current banner
    function updateBannerContent(subheading, textLink, link) {
        $('#subheading').html(subheading);
        $('#bannerBtn').html(textLink);
        $('#bannerBtn').attr('href', link);
    }

    // Function to calculate typing duration
    function getTypingDuration(text, speedPerChar = 0.1) {
        return text.length * speedPerChar;
    }

    // Toilet Banner 1 Timeline
    var toiletBanner = new gsap.timeline({
        paused: true,
        yoyo: true,
        repeat: 1,
        onComplete: () => {
            toiletBanner2.restart();
        },
        onStart: () => {
            updateBannerContent(subheading1, textLink1, link1);
            gsap.set('#looImages1 img, #toiletSite, #toiletEvent, #toiletSite2', { autoAlpha: 0 });
        }
    });

    // Calculate typing duration for textContent1
    var typingDuration1 = getTypingDuration(textContent1, 0.1);

    toiletBanner.to('#text_typing_animation', {
        text: { value: textContent1 },
        duration: typingDuration1,
        ease: "none"
    }, 0);

    toiletBanner.to('#text_line', {
        width: "100%",
        duration: typingDuration1,
        ease: "none"
    }, 0);

    toiletBanner.fromTo('#looImages1 img', { autoAlpha: 0 }, { delay: 0.5, autoAlpha: 1, stagger: 0.2 }, 0);
    toiletBanner.fromTo('#toiletSite', { autoAlpha: 0, y: '10px' }, { autoAlpha: 1, y: '0', delay: 0.2 }, 0);
    toiletBanner.fromTo('#toiletEvent', { autoAlpha: 0, y: '10px' }, { autoAlpha: 1, y: '0', delay: 0.4 }, 0);
    toiletBanner.fromTo('#toiletSite2', { autoAlpha: 0, y: '10px' }, { autoAlpha: 1, y: '0', delay: 0.6 }, 0);

    toiletBanner.to('#text_typing_animation', { xPercent: 0, delay: 2 }, '+=0');

    // Toilet Banner 2 Timeline
    var toiletBanner2 = new gsap.timeline({
        paused: true,
        repeat: 1,
        yoyo: true,
        onComplete: () => {
            toiletBanner3.restart();
        },
        onStart: () => {
            updateBannerContent(subheading2, textLink2, link2);
            gsap.set('#looImages2 img, #toiletDisabled, #toiletDisabled2', { autoAlpha: 0 });
        }
    });

    // Calculate typing duration for textContent2
    var typingDuration2 = getTypingDuration(textContent2, 0.1);

    toiletBanner2.to('#text_typing_animation', {
        text: { value: textContent2 },
        duration: typingDuration2,
        ease: "none"
    }, 0);

    toiletBanner2.to('#text_line', {
        width: "100%",
        duration: typingDuration2,
        ease: "none"
    }, 0);

    toiletBanner2.fromTo('#looImages2 img', { autoAlpha: 0 }, { delay: 0.5, autoAlpha: 1, stagger: 0.2 }, 0);
    toiletBanner2.fromTo('#toiletDisabled', { autoAlpha: 0, y: '10px' }, { autoAlpha: 1, y: '0', delay: 0.2 }, 0);
    toiletBanner2.fromTo('#toiletDisabled2', { autoAlpha: 0, y: '10px' }, { autoAlpha: 1, y: '0', delay: 0.4 }, 0);

    toiletBanner2.to('#text_typing_animation', { xPercent: 0, delay: 2 }, '+=0');

    // Toilet Banner 3 Timeline
    var toiletBanner3 = new gsap.timeline({
        paused: true,
        repeat: 1,
        yoyo: true,
        onComplete: () => {
            toiletBanner.restart();
        },
        onStart: () => {
            updateBannerContent(subheading3, textLink3, link3);
            gsap.set('#looImages3 img, #toiletVip', { autoAlpha: 0 });
        }
    });

    // Calculate typing duration for textContent3
    var typingDuration3 = getTypingDuration(textContent3, 0.1);

    toiletBanner3.to('#text_typing_animation', {
        text: { value: textContent3 },
        duration: typingDuration3,
        ease: "none"
    }, 0);

    toiletBanner3.to('#text_line', {
        width: "100%",
        duration: typingDuration3,
        ease: "none"
    }, 0);

    toiletBanner3.fromTo('#looImages3 img', { autoAlpha: 0 }, { delay: 0.5, autoAlpha: 1, stagger: 0.2 }, 0);
    toiletBanner3.fromTo('#toiletVip', { autoAlpha: 0, x: '100px' }, { autoAlpha: 1, x: '0', delay: 0.2 }, 0);

    toiletBanner3.to('#text_typing_animation', { xPercent: 0, delay: 2 }, '+=0');

    // Start the animation sequence
    $(window).on("load", function (e) {
        toiletBanner.play();
    });

}

// TABS SLIDER
var tabsSwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    pagination: {
        clickable: true,
        el: '.tabs-slider__pagination'
    },
    scrollbar: {
        hide: false,
        draggable: true,
        el: '.tabs-slider__scrollbar'
    },
};
var tabswiper = new Swiper(".tabs-slider", tabsSwiperOptions);

tabswiper.on('init', tabSliderActive());

tabswiper.on('activeIndexChange', function () {
    tabSliderActive();
});

function tabSliderActive() {
    var tabId = $('.swiper-slide[data-slide-id="' + (tabswiper.activeIndex + 1) + '"]').data('tab-id');
    $('.tab-button').removeClass('active_tab');
    $('.tab-button[data-tab-id="' + tabId + '"]').addClass('active_tab');
}

$(document).on("click", ".tab-button", function (e) {
    var tabId = $(this).data('tab-id');
    var slide = $('.swiper-slide[data-tab-id="' + (tabId - 1) + '"]');
    var slideId = slide.data('slide-id');
    tabswiper.slideTo(slideId);

    $('.tab-button[data-tab-id="' + tabId + '"]');
});

if ($('.toilet_calculator').length) {
    $(".card_loo").each(function (i) {
        let delay_time = (i + 1) * .2;
        var loosCard = new gsap.timeline({
            scrollTrigger: {
                trigger: $('.toilet_calculator'),
                start: "top center",
                animation: loosCard,
            },
        });
        loosCard.fromTo(this, { opacity: 0, x: '30px' }, { opacity: 1, x: '0', delay: delay_time }, 0)
    })
}

if ($('.aggregate_calculator').length) {
    $(".card_agr").each(function (i) {
        let delay_time = (i + 1) * .2;
        var loosCard = new gsap.timeline({
            scrollTrigger: {
                trigger: $('.aggregate_calculator'),
                start: "top center",
                animation: loosCard,
            },
        });
        loosCard.fromTo(this, { opacity: 0, x: '30px' }, { opacity: 1, x: '0', delay: delay_time }, 0)
    })
}

// --------------------------
// Stripe
// --------------------------

if ($("#checkoutForm").length > 0) {
    window.addEventListener("pageshow", function (event) {
        var historyTraversal =
            event.persisted ||
            (typeof window.performance != "undefined" &&
                window.performance.navigation.type === 2);
        if (historyTraversal) {
            window.location.reload();
        }
    });

    let stripe = Stripe($('meta[name="stripe-key"]').attr("content"));
    let elements = stripe.elements();
    let style = {
        base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    };
    var cardElement = elements.create("card", {
        style: style,
        hidePostalCode: true,
    });
    document.addEventListener('livewire:init', () => {
        Livewire.on('startPayment', (event) => {
            setTimeout(() => {
                cardElement.mount("#card-element");
                cardElement.on("change", function (event) {
                    var displayError = document.getElementById("card-errors");
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = "";
                    }
                });

                $(document).on("click", "#card-button", function (e) {
                    e.preventDefault();
                    $("#card-button").attr("disabled", true)
                    axios
                        .post("/checkout/order", $("#checkoutForm").serialize())
                        .then((response) => {
                            $(".form-errors").addClass("d-none");
                            if (
                                response.data.order_id < 1 ||
                                !response.data.id ||
                                !response.data.client_secret
                            ) {
                                $("#card-button").html("Place Order");
                                $("#card-button").attr("disabled", false);
                                return false;
                            }
                            $("#pi").val(response.data.id);
                            $("#po_number, #po_contact_name, #po_contact_number")
                                .attr("required", false)
                                .prop("required", false);

                            var cardholderName =
                                $("#billing_first_name").val() +
                                " " +
                                $("#billing_last_name").val();
                            var billAddressOne = $("#billing_address_one").val();
                            var billAddressTwo = $("#billing-address_two").val();
                            var billTown = $("#billing_town_city").val();
                            var billCounty = $("#billing_county_region").val();
                            var billPostcode = $("#billing_postcode").val();
                            var billCountry = "GB";
                            var billTelephone = $("#billing_telephone").val();

                            var email = $("#email").val();

                            if (email != "was@qualys.com") {
                                stripe
                                    .confirmCardPayment(response.data.client_secret, {
                                        payment_method: {
                                            card: cardElement,
                                            billing_details: {
                                                name: cardholderName,
                                                address: {
                                                    city: billTown,
                                                    country: billCountry,
                                                    line1: billAddressOne,
                                                    line2: billAddressTwo,
                                                    postal_code: billPostcode,
                                                    state: billCounty,
                                                },
                                                phone: billTelephone,
                                            },
                                        },
                                    })
                                    .then(function (result) {
                                        var displayError =
                                            document.getElementById("card-errors");
                                        if (result.error) {
                                            displayError.textContent = result.error.message;
                                            $("#card-button").html("Place Order");
                                            $("#card-button").attr("disabled", false);
                                        } else {
                                            displayError.textContent = "";
                                            $("#checkoutForm").submit();
                                        }
                                    });
                            } else {
                                $("#card-button").html("Place Order");
                                $("#card-button").attr("disabled", false);
                            }
                        })
                        .catch(function (error) {
                            $(".form-errors").removeClass("d-none");
                            $(".error-heading").html(error.response.data.message);
                            $(".error-messages").html("");
                            for (const [key, value] of Object.entries(
                                error.response.data.errors
                            )) {
                                value.forEach((msg) => {
                                    $(".error-messages").append("<li>" + msg + "</li>");
                                });
                            }
                            $("html, body").animate(
                                {
                                    scrollTop: $(".form-errors").offset().top - 16,
                                },
                                350
                            );
                            $("#card-button").html("Place Order");
                            $("#card-button").attr("disabled", false);
                        });
                });
            }, 1000)
        });
    })
}

// CONTENT TAB SWIPER
if ($('.content-tab-swiper').length) {
    let contentSwiper = new Swiper(".content-tab-swiper", {
        slidesPerView: 1,
        grabCursor: true,
        spaceBetween: 10,
        mousewheel: true,
        keyboard: true,
        speed: 500,
        loop: true,
        initialSlide: 0,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        scrollbar: {
            hide: false,
            draggable: true,
            el: '.content-tab-swiper__scrollbar'
        },
    });
}

// CONTENT TAB SWIPER
if ($('.landing-page-image-swiper').length) {
    let landingPageImageSwiper = new Swiper(".landing-page-image-swiper", {
        slidesPerView: 2,
        grabCursor: true,
        spaceBetween: 15,
        mousewheel: true,
        keyboard: true,
        speed: 300,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });
}
